// extracted by mini-css-extract-plugin
export default {"app":"AppLayout_app__m1ube","body-container":"AppLayout_body-container__jJ7e+","center":"AppLayout_center__tc6YD"};